<div class="link-modal">
  <div class="modal-head">
    <div class="title-block">
      <h2>Account Creation Link</h2>
      <p class="sub">Share this link with the user to set up their account.</p>
    </div>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="user-row" *ngIf="accounUser?.name">
      <div class="avatar">
        <img *ngIf="accounUser.profile_pic"
             [src]="dataSharedService.getImage(accounUser.profile_pic)"
             [alt]="accounUser.name" />
        <span *ngIf="!accounUser.profile_pic">
          {{ authService.getInitials(accounUser.name) }}
        </span>
      </div>
      <div class="meta">
        <div class="name">{{ accounUser.name }}</div>
        <div class="muted">Account user</div>
      </div>
    </div>

    <div class="field">
      <label>Account link</label>
      <div class="link-input-wrap">
        <input type="text" class="input-form" [value]="accountCreationLink" readonly />
        <button type="button" class="btn btn-primary copy-btn"
          (click)="copyLink(accountCreationLink)">
          <i class="bi bi-clipboard"></i>
          <span>Copy</span>
        </button>
      </div>
    </div>
  </div>
</div>
